/**
 * Navigation Menu Toggle
 */

export function initNavigation() {
    const largeNav = document.querySelector('[data-nav-large]');
    const smallNav = document.querySelector('[data-nav-small]');
    const body = document.body;
    
    if (!largeNav || !smallNav) return;
    
    // Function to check if screen is desktop (>= 1024px)
    const isDesktop = () => window.innerWidth >= 1024;
    
    // Check if we're on the home page
    const isHomePage = body.classList.contains('home') || body.classList.contains('page-template-tpl-home');
    
    const updateNavigation = () => {
        if (!isDesktop()) {
            // Mobile/tablet: always show large nav
            largeNav.classList.add('translate-x-0');
            largeNav.classList.remove('-translate-x-full');
        } else {
            // Desktop: apply the original behavior
            if (isHomePage) {
                // Home page: show large nav, hide small nav
                largeNav.classList.add('translate-x-0');
                largeNav.classList.remove('-translate-x-full');
                smallNav.classList.add('opacity-0', 'pointer-events-none');
                smallNav.classList.remove('opacity-100');
            } else {
                // Other pages: show small nav, hide large nav initially
                largeNav.classList.add('-translate-x-full');
                largeNav.classList.remove('translate-x-0');
                smallNav.classList.add('opacity-100');
                smallNav.classList.remove('opacity-0', 'pointer-events-none');
            }
        }
    };
    
    // Initial setup
    updateNavigation();
    
    // Update on resize
    window.addEventListener('resize', updateNavigation);
    
    // Hover interactions only for desktop
    if (isDesktop()) {
        // Add hover interaction for small nav
        smallNav.addEventListener('mouseenter', () => {
            if (isDesktop() && !isHomePage) {
                largeNav.classList.remove('-translate-x-full');
                largeNav.classList.add('translate-x-0');
                smallNav.classList.add('opacity-0');
                smallNav.classList.remove('opacity-100');
            }
        });
        
        // When mouse leaves large nav, show small nav again
        largeNav.addEventListener('mouseleave', () => {
            if (isDesktop() && !isHomePage) {
                largeNav.classList.add('-translate-x-full');
                largeNav.classList.remove('translate-x-0');
                smallNav.classList.remove('opacity-0');
                smallNav.classList.add('opacity-100');
            }
        });
    }
}